import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SpFormControlsModule } from '../sp-form-controls/sp-form-controls.module';
import { SpAdvancedRadiusSettingsComponent } from './sp-advanced-radius-settings.component';

@NgModule({
    imports: [CommonModule, TranslateModule, SpFormControlsModule, TooltipModule, SpAdvancedRadiusSettingsComponent],
    exports: [SpAdvancedRadiusSettingsComponent],
})
export class SpAdvancedRadiusSettingsModule {}
